import { Component, OnInit } from '@angular/core';
import { InitService } from '../../services/init.service';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'app-redirect-app',
  templateUrl: './redirect-app.component.html',
})
export class RedirectAppComponent implements OnInit {
  appleStoreUrl: string = '';
  googlePlayUrl: string = '';
  loading: boolean = false;
  
  constructor(private initService: InitService, private tenantService: TenantService ) {}
  
  ngOnInit(): void {
    this.loading = true;
    this.tenantService.getTenantAppUrlByTenantId(this.initService.tenantConfigurations.tenantId).subscribe(
      (appUrl) => {      
        this.appleStoreUrl = appUrl.appleStoreUrl;
        this.googlePlayUrl = appUrl.playStoreUrl;
        this.loading = false;
        this.redirectToApp();
      },
      (error) => {
        console.error('Error fetching app URLs:', error);
        this.loading = false;
      });

  }

  // This method is used to redirect the user to the app store or play store based on the device type
  // It checks the user agent string to determine if the device is Android or iOS
  redirectToApp() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
      window.location.href = this.googlePlayUrl;
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
      window.location.href = this.appleStoreUrl;
    }
  }

}
